// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3jFRT","label":"SetPasswdForm_label__IsXLP"};